import { useId } from 'react';
import { Textarea } from '@monksflow/monks-ui';
import { AlignLeftIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { KnowledgeBaseFormFieldV2 } from './KnowledgeBaseFormFieldV2';
import type { KnowledgeBaseFormDescriptionProps } from '../KnowledgeBaseFormDescription/KnowledgeBaseFormDescription.types';

export const DESCRIPTION_MAX_LENGTH = 200;

/**
 * Tessra twin of `KnowledgeBaseFormDescription`. Same props, so the two are
 * interchangeable at the call site.
 */
export const KnowledgeBaseFormDescriptionV2 = ({
  description,
  setDescription,
  error,
}: KnowledgeBaseFormDescriptionProps) => {
  const { t } = useTranslation('knowledge');

  const fieldId = useId();
  const helpId = useId();
  const errorId = useId();

  return (
    <KnowledgeBaseFormFieldV2
      icon={AlignLeftIcon}
      title={t('knowledgeBases.knowledgeBaseFormDescription.description')}
      description={t('knowledgeBases.knowledgeBaseFormDescription.giveADescriptionToExplain')}
      required
      fieldId={fieldId}
      descriptionId={helpId}
    >
      <div className="flex flex-col gap-2xs">
        <Textarea
          id={fieldId}
          value={description}
          rows={3}
          maxLength={DESCRIPTION_MAX_LENGTH}
          required
          aria-invalid={!!error}
          aria-describedby={error ? `${helpId} ${errorId}` : helpId}
          placeholder={t('knowledgeBases.knowledgeBaseFormDescription.eGBrandSPurpose')}
          onChange={(event) => setDescription(event.target.value)}
        />
        <span
          id={error ? errorId : undefined}
          role={error ? 'alert' : undefined}
          className={`type-body-sm ${error ? 'text-destructive' : 'text-muted-foreground'}`}
        >
          {error || `${description.length}/${DESCRIPTION_MAX_LENGTH}`}
        </span>
      </div>
    </KnowledgeBaseFormFieldV2>
  );
};

KnowledgeBaseFormDescriptionV2.displayName = 'KnowledgeBaseFormDescriptionV2';
